(() => {
  const KEY = 'EasyGamesCartDisclosureLoaderV1';
  if (window[KEY]) return window[KEY].scan();

  const entry = document.currentScript || [...document.scripts].find((s) => s.src.includes('/cart-disclosure-modal.js'));
  const base = entry?.src ? new URL('.', entry.src) : null;
  const state = { done: false, promise: null, observer: null };
  const loaded = new Set();
  const hasDisclosure = () => Boolean(document.querySelector('.cart-item__disclosure,cart-disclosure-modal'));

  const add = (filename) => {
    if (loaded.has(filename)) return Promise.resolve();
    return new Promise((resolve, reject) => {
      if (!base) return reject(new Error(`Unable to resolve ${filename}`));
      const script = document.createElement('script');
      script.src = new URL(filename, base).href;
      script.async = false;
      script.onload = () => { loaded.add(filename); resolve(); };
      script.onerror = (error) => { script.remove(); reject(error); };
      document.head.appendChild(script);
    });
  };

  const stop = () => {
    state.observer?.disconnect();
    state.observer = null;
  };

  const watch = () => {
    if (state.done || state.promise || state.observer) return;
    const roots = document.querySelectorAll('cart-drawer,cart-notification,cart-items');
    if (!roots.length) return;
    state.observer = new MutationObserver(scan);
    roots.forEach((root) => state.observer.observe(root, { childList: true, subtree: true }));
  };

  const load = () => {
    if (state.done) return Promise.resolve();
    if (state.promise) return state.promise;
    state.promise = Promise.all([
      add('cart-disclosure-modal-core-v1.js'),
      add('cart-disclosure-tooltip-core-v1.js'),
    ])
      .then(() => {
        state.done = true;
        stop();
      })
      .catch((error) => {
        state.promise = null;
        console.warn('[EASY GAMES] Cart disclosure assets could not be loaded.', error);
        watch();
      });
    return state.promise;
  };

  function scan() {
    if (!state.done && hasDisclosure()) void load();
  }

  window[KEY] = { scan, load };
  scan();
  watch();
  document.addEventListener('shopify:section:load', scan);
})();
